import styled from "styled-components";

export const StyledTemplateCard = styled.div`
    width: 100%;
    border-radius: 20px;
    border: 1px solid rgba(233, 233, 233, 1);
    overflow: hidden;
    cursor: pointer;
    &:hover {
        .img-wrap {
            &::before {
                opacity: 1;
            }
            .btn-wrap {
                opacity: 1;
            }
        }
    }
    .img-wrap {
        position: relative;
        padding: 24px 12px 0;
        background-color: rgba(236, 236, 236, 1);
        margin-bottom: 17px;
        .bannerImg {
            width: 100%;
        }
        &::before {
            content: "";
            position: absolute;
            inset: 0;
            background-color: rgba(49, 49, 49, 0.6);
            opacity: 0;
            transition: all 0.2s ease-in-out;
        }
        .btn-wrap {
            position: absolute;
            left: 50%;
            bottom: 20px;
            transform: translateX(-50%);
            display: flex;
            justify-content: center;
            gap: 11px;
            transition: all 0.2s ease-in-out;
            opacity: 0;
            .preview-btn {
                background-color: rgba(233, 233, 233, 1);
                color: rgba(119, 119, 119, 1);
            }
        }
    }
    .details-wrap {
        padding: 20px;
        .template-head {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 12px;
            margin-bottom: 12px;
            .template-title {
                color: var(--text-color);
                font-size: 20px;
                line-height: 24px;
                font-weight: 500;
            }
            .template-label {
                background: rgba(245, 126, 42, 0.2);
                border-radius: 30px;
                padding: 7px 10px;
                color: var(--primary);
                font-size: 12px;
                line-height: 16px;
                font-weight: 500;
            }
        }
        .desc {
            color: rgba(119, 119, 119, 1);
            font-size: 14px;
            line-height: 18px;
            font-weight: 300;
            margin-bottom: 15px;
        }
        .tabs-wrap {
            max-width: 250px;
            list-style: none;
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
            .tab {
                border: 1px solid rgba(233, 233, 233, 1);
                border-radius: 30px;
                padding: 7px 10px;
                color: var(--text-color);
                font-size: 12px;
                line-height: 16px;
                font-weight: 400;
            }
        }
    }
`;
